import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { type ClientError } from 'graphql-request'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandAccountAllowedDomainListPage_RemoveBrandAccountAllowDomain(
    $input: RemoveBrandAccountAllowDomainInput!
  ) {
    removeBrandAccountAllowDomain(input: $input) {
      result
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useRemoveBrandAccountAllowDomainMutation = (
  options: Omit<
    UseMutationOptions<Data, ClientError, Variables['input'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation<Data, ClientError, Variables['input']>({
    mutationFn: (input) => graphQLRequest({ document, variables: { input } }),
    ...options,
  })
}
